import api from "./api";

export const fetchDashboardSummary = async () => {
  try {
    const response = await api.get("/dashboard/summary");
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to load dashboard summary";
  }
};

export const fetchCertificates = async () => {
  try {
    const response = await api.get("/certificate/certificates");
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to fetch certificates";
  }
};

export const importCertificatesCsv = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post(
      "/certificate/certificates/import",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "CSV import failed";
  }
};

export const issueCertificate = async (payload: any) => {
  try {
    const response = await api.post("/certificate/create", payload);
    return response.data;
  } catch (error: any) {
    throw error.response?.data?.message || "Failed to issue certificate";
  }
};

export const editCertificate = async (certId: string | number, payload: any) => {
  try {
    console.log("🟡 Editing certificate:", certId);
    console.log("🟡 Full payload received:", payload);
    // Send the full payload received from the UI to the backend.
    // Backend often expects many of the fields (first_name, last_name, student_name, course_name, etc.).
    const updatePayload = { ...payload };

    console.log("🟡 Final payload sent to backend:", updatePayload);

    const response = await api.put(`/certificate/certificates/${certId}`, updatePayload);
    console.log("✅ Edit response:", response.data);

    return response.data;
  } catch (error: any) {
    console.error("❌ Edit API Error:");
    console.error("  Status:", error.response?.status);
    console.error("  Data:", error.response?.data);
    console.error("  Message:", error.message);

    const status = error.response?.status;
    const data = error.response?.data;
    const message = data?.message || data?.detail || error.message || "Backend API error: Check if you're authenticated and have admin permissions.";

    // If server returned 500, attempt a sanitized retry: convert empty strings to null and remove undefined keys.
    if (status === 500) {
      try {
        console.log("🟠 Attempting sanitized retry for certificate:", certId);
        const sanitized: any = { ...payload };
        Object.keys(sanitized).forEach((k) => {
          if (sanitized[k] === "") sanitized[k] = null;
          if (sanitized[k] === undefined) delete sanitized[k];
        });
        console.log("🟠 Sanitized payload:", sanitized);
        const retryResp = await api.put(`/certificate/certificates/${certId}`, sanitized);
        console.log("✅ Retry response:", retryResp.data);
        return retryResp.data;
      } catch (e: any) {
        console.error("❌ Retry failed:", e.response?.status, e.response?.data, e.message);
        const errObj = {
          message: e.response?.data?.message || e.message || message,
          status: e.response?.status || status,
          response: e.response?.data || data,
        };
        throw errObj;
      }
    }

    const errObj = { message, status, response: data };
    throw errObj;
  }
};

export const deleteCertificate = async (certId: string | number) => {
  try {
    console.log("🔴 Deleting certificate:", certId);

    const response = await api.delete(`/certificate/certificates/${certId}`);

    return response.data;
  } catch (error: any) {
    console.error("❌ Delete failed:", {
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    const errMsg = error.response?.data?.message || error.message || "Failed to delete certificate";
    throw errMsg;
  }
};


// ===================================
// NEW: Download sample certificate template
// ===================================
export const downloadSampleCertificateFile = async (format: 'csv' | 'xlsx' = 'csv') => {
  try {
    const response = await api.get(`/certificate/download-sample?format=${format}`, {
      responseType: 'blob', // Important for file downloads
    });
    
    // Create a download link and trigger it
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    
    // Get filename from Content-Disposition header or use default
    const contentDisposition = response.headers['content-disposition'];
    let filename = `certificate_template.${format}`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }
    
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return { success: true, filename };
  } catch (error: any) {
    console.error("❌ Download sample failed:", error);
    throw error.response?.data?.message || "Failed to download sample file";
  }
};

